<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="modal-body">
      <CRow>
        <div v-for="(item, index) in data_comprobante_pago" :key="index" :class="[
          'col',
          'border',
          colClass,
          'd-flex',
          'font-bold',
          item.selected ? 'bg-info text-white' : 'bg-gris',
          'container-type',
        ]" @click="selectItem(item.value)">
          <div class="text text-center">{{ item.label }}</div>
        </div>
      </CRow>
      <CRow class="mt-2">
        <CCol sm="12" lg="4">
          <CInput :label="isFactura ? 'RUC' : 'Dni Cliente'" :placeholder="isFactura ? 'Digite RUC' : 'Digite DNI'"
            :maxlength="isFactura ? 11 : 8" v-model="sale.entity_document" @keyup="mtdSearchDocument" />
          <div v-if="
            isFactura &&
            isRUCValid &&
            this.sale.entity_document &&
            this.sale.entity_document.length !== 11
          " class="text-danger">
            El RUC debe contener solo números y hasta 11 dígitos.
          </div>
        </CCol>
        <CCol sm="12" lg="8">
          <CInput :label="isFactura ? 'Razón social' : 'Nombre Cliente'"
            :placeholder="isFactura ? 'Digite razón social' : 'nombre'" v-model="sale.entity_name" disabled />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="4">
          <label for="adjustmentType">Tipo de ajuste</label>
          <select id="adjustmentType" v-model="adjustmentType" class="form-control">
            <option v-for="(item, index) in adjustmentTypes" :key="index" :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </CCol>
        <CCol lg="4">
          <label for="adjustmentOption">Unidad de ajuste</label>
          <select id="adjustmentOption" v-model="option" class="form-control">
            <option v-for="(item, index) in options" :key="index" :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </CCol>
        <CCol lg="4">
          <CInput label="Monto ajuste" type="number" min="0" v-model="adjustmentAmount" @blur="updateAjustment"
            :disabled="cpAdjunstmentAmount" />
        </CCol>
      </CRow>
      <CRow>
        <div class="col-lg-4 col-12">
          <h6>MÉTODO DE PAGO</h6>
          <table>
            <tbody v-if="data_metodo_pago.length == 0">
              <tr>
                <td>Sin Metodos de Pago (Agregue en Mantenimiento)</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in data_metodo_pago" :key="index">
                <td v-if="item.label != 'MIXTO'">{{ item.label }}</td>
                <td v-if="item.label != 'MIXTO'">
                  <input type="number" class="form-control" placeholder="0" v-model="item.amount"
                    @keyup="updateSelectedPayments(item)" min="0" />
                </td>
              </tr>
              <tr>
                <td>PENDIENTE COMPLETAR</td>
                <td>
                  <input class="form-control" v-model="cpPendingPayment" disabled />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-8 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="mb-3">
                <CInput label="TOT. CITA S/" :value="totalCita" readonly />
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="mb-3">
                <CInput label="TOT. PRODUCTO S/" :value="totalProducts" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="TOT. VENTA" :value="sale.total" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="PAGADO" :value="pagoCliente" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="PENDIENTE" :value="pendiente" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="AJUSTE" :value="parseFloat(sale.adjustment).toFixed(2)" readonly />
              </div>
            </div>
            <CCol sm="4">
              <div class="mb-3">
                <CInput label="TOT. PAGAR" :value="pagoTotal" readonly />
              </div>
            </CCol>
            <CCol sm="4">
              <CInput label="VUELTO S/" :value="cpVuelto" readonly />
            </CCol>
            <CCol v-if="this.turned.amount > 0" sm="12">
              <CSelect label="Método de pago del vuelto" :value.sync="turned.method" :options="turnedMethod"
                placeholder="--Seleccione un metodo--" />
            </CCol>
          </div>
        </div>
      </CRow>
    </div>
    <template #footer>
      <button @click="mtdClose(false)" class="btn btn-sm btn-danger">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="mtd_action" :disabled="cpButton" class="btn btn-info btn-sm">
        <i class="fas fa-dollar-sign"></i> Pagar
      </button>
      &nbsp;
    </template>
  </CModal>
</template>
<script>
import { mapActions } from "vuex";
import CModal from "../../shared/modals/cModalFormCom.vue";

export default {
  name: "c-payment-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "cita",
      adjustmentType: 0,
      adjustmentTypes: [
        { label: "[Escoja una opción..]", value: 0 },
        { label: "Aumento", value: 1 },
        { label: "Descuento", value: 2 },
      ],
      option: 0,
      options: [
        { label: "[Escoja una opción..]", value: 0 },
        { label: "Soles", value: 1 },
        { label: "%", value: 2 },
      ],
      adjustmentAmount: 0,
      data_comprobante_pago: [],
      data_metodo_pago: [],
      selectedPayments: [],
      data_products: [],
      sale: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        client_id: "",
        // barber_id: "",
        date: "",
        // method: "",
        // type: "",
        total: "" /** monto total del servicio */,
        amount: "" /**monto pagado - adelanto */,
        pending: 0 /** pendiente */,
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        ruc: "",
        state: 0,
        // existingSportman: true,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        quote_id: "",
        sale_id: "",
      },
      isRUCValid: false, //estado de validación
      /** turned */
      turnedMethod: [],
      turned: {
        amount: 0,
        method: 0,
      },
      disabledButton: true
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    total_pay: String,
    id_sale: Number,
    // id_barber: Number,
    id_client: Number,
    client_document: String,
    client_name: String,
    detail_product: Array,
    item: Object,
  },
  watch: {
    boo_modal(newVal){
      if(newVal){
        this.showBead();
      }
    },
    item(newVal) {
      if (newVal != undefined) {
        // if(newVal.sale){
        this.sale.pendigPayment = newVal.sale.pending;
        // }
      }
    },
    total_pay(newVal) {
      this.sale.total = newVal;
      this.sale.amount = newVal;
    },
    id(newVal) {
      this.sale.quote_id = newVal;
    },
    id_sale(newVal) {
      this.sale.sale_id = newVal;
    },
    // id_barber(newVal) {
    //   this.sale.barber_id = newVal;
    // },
    id_client(newVal) {
      this.sale.client_id = newVal;
    },
    client_document(newVal) {
      this.sale.entity_document = newVal;
    },
    client_name(newVal) {
      this.sale.entity_name = newVal;
    },
    detail_product(newVal) {
      this.data_products = newVal;
    },
    "sale.sale_id"(newWal) {
      if (newWal) {
        this.showSale(newWal);
        this.sale.id = newWal;
      }
    },
  },
  computed: {
    cpButton() {
      const isFacturaValid =
        this.isFactura &&
        this.isRUCValid &&
        this.sale.entity_document &&
        this.sale.entity_document.length == 11;
      if (isFacturaValid) {
        return (
          !this.sale.entity_document ||
          !this.sale.entity_name ||
          !this.sale.document_type_id ||
          !this.selectedPayments.length ||
          this.disabledButton ||
          !isFacturaValid
        );
      } else {
        return (
          !this.sale.entity_document ||
          !this.sale.entity_name ||
          !this.sale.document_type_id ||
          !this.selectedPayments.length ||
          this.disabledButton
        );
      }
    },
    isFactura() {
      return this.sale.document_type_id == 2; // Asume que el ID de Factura es 2
    },
    colClass() {
      const itemsCount = this.data_comprobante_pago.length;
      if (itemsCount === 1) return "col-12";
      if (itemsCount === 2) return "col-6";
      if (itemsCount === 3 || itemsCount == 6) return "col-4";
      return "col-6";
    },
    // Suma de los pagos seleccionados
    pagoCliente() {
      return parseFloat(this.sale.amount).toFixed(2);
    },
    // Calcular el monto pendiente a pagar
    pendiente() {
      return this.sale.pending;
    },
    //PAGO TOTAL
    pagoTotal() {
      let tot = 0;
      if (this.sale.adjustment < 0) {
        tot =
          parseFloat(this.sale.pending) - parseFloat(this.sale.adjustment * -1);
      } else {
        tot = parseFloat(this.sale.pending) + parseFloat(this.sale.adjustment);
      }
      this.sale.pendigPayment = tot;
      return tot;
    },
    //Vuelto
    cpVuelto() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      let pend = this.pagoTotal == 0 ? this.sale.total : this.pagoTotal;

      if (totalPayments > 0) {
        if (parseFloat(totalPayments - pend).toFixed(2) > 0) {
          this.turned.amount = parseFloat(totalPayments - pend).toFixed(2);
          return parseFloat(totalPayments - pend).toFixed(2);
        } else {
          this.turned.amount = 0;
          return 0;
        }
      }
      this.turned.amount = 0;
      return 0;
    },
    totalProducts() {
      if (this.data_products && Array.isArray(this.data_products)) {
        const total = this.data_products.reduce((sum, product) => {
          return sum + (parseFloat(product.price) || 0);
        }, 0);
        return total.toFixed(2);
      }
      return "0.00";
    },
    totalCita() {
      if (
        this.data_products &&
        Array.isArray(this.data_products) &&
        this.sale.amount
      ) {
        const total_product = parseFloat(this.totalProducts);
        const total = this.sale.total - total_product;
        return total.toFixed(2);
      }
      return this.sale.total;
    },
    cpAdjunstmentAmount() {
      if (this.adjustmentType > 0 && this.option > 0) {
        this.updateAjustment();
        return false;
      }
      this.sale.adjustment = 0;
      return true;
    },
    cpPendingPayment() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      if (totalPayments == 0) {
        this.disabledButton = true;
        return this.pagoTotal == 0 ? this.sale.total : this.pagoTotal;
      }
      let pendientePago = parseFloat(this.sale.pendigPayment);
      let pagosTotales = parseFloat(totalPayments);

      // let res = parseFloat(this.sale.pendigPayment) == 0 ? this.sale.total : parseFloat(this.sale.pendigPayment) - parseFloat(totalPayments);
      let res = pendientePago === 0 ? (this.sale.total - pagosTotales).toFixed(2) : (pendientePago - pagosTotales).toFixed(2);

      this.disabledButton = res <= 0 ? false : true;
      return res < 0 ? 0 : res;
    },
  },
  created() {
    this.showDocumentType();
    this.showMethodPayment();
    // this.showBead();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose(refresh) {
      this.resetFormData();
      this.$emit("closeModalPaymentBooking", refresh);
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let bead = response.data;
          this.sale.bead_id = bead.id;
        })
        .catch((errors) => { });
    },
    showDocumentType() {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/byDocumentType",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_comprobante_pago.push({
              label: name,
              value: id,
              selected: false,
            });
          });
        })
        .catch((errors) => { });
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { Id, name } = arr;
            this.data_metodo_pago.push({
              label: name,
              value: Id,
              amount: "",
            });
            this.turnedMethod.push({
              label: name,
              value: Id,
            });
          });
        })
        .catch((errors) => { });
    },
    selectItem(index) {
      this.sale.document_type_id = index;
      this.data_comprobante_pago.forEach((item, idx) => {
        item.selected = idx === index - 1;
      });
      // Resetear los valores según el tipo de comprobante seleccionado
      if (this.isFactura) {
        this.isRUCValid = true; // Reinicia la validación del RUC
      } else {
        this.isRUCValid = false;
      }
      // this.mtdSearchDocument();
    },
    updateSelectedPayments(item) {
      if (item.amount < 0) {
        item.amount = 0;
        return;
      }
      // Elimina cualquier elemento existente con el mismo ID
      if (item.amount === "" || parseFloat(item.amount) === 0) {
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );
        return;
      }
      let newTotal;
      if (item.amount) {
        // Elimina cualquier elemento existente con el mismo ID
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );

        newTotal =
          this.selectedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount),
            0
          ) + parseFloat(item.amount);
      }
      // Verifica que la suma de selectedPayments no exceda el sale.total
      if (this.sale.sale_id) {
        if (newTotal <= this.sale.pending) {
          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        } else {
          this.selectedPayments.push({
            id: item.value,
            label: item.label,
            amount: item.amount,
          });
        }
      } else {
        if (newTotal <= this.sale.amount) {
          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        } else {
          this.selectedPayments.push({
            id: item.value,
            label: item.label,
            amount: item.amount,
          });
        }
      }
    },
    mtd_action: function () {
      if (
        this.isFactura &&
        this.isRUCValid &&
        this.sale.entity_document &&
        this.sale.entity_document.length != 11
      ) {
        Swal.fire({
          title: "El RUC no es válido. Debe tener 11 dígitos.",
          icon: "error",
        });
        return;
      } else if (
        this.sale.entity_document == "" ||
        this.sale.entity_name == ""
      ) {
        Swal.fire({
          title: "Agregue datos del cliente",
          icon: "error",
        });
        return;
      }
      if(this.turned.amount > 0 && this.turned.method == 0 && this.turned.amount){
        Swal.fire({
          title: "Agregue metodo de pago para el vuelto",
          icon: "error",
        });
        return;
      }
      this.sale.option = this.option;
      if(this.option == 1 ){
        this.sale.adjustment = this.adjustmentType == 1 ? parseFloat(this.adjustmentAmount).toFixed(2) : parseFloat(this.adjustmentAmount * -1).toFixed(2);
      }else{
        const total = this.sale.total;
        let tempAdjustment = (total * this.adjustmentAmount) / 100;
        this.sale.adjustment = this.adjustmentType == 1 ? parseFloat(tempAdjustment).toFixed(2) : parseFloat(tempAdjustment * -1).toFixed(2);
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/storeSale",
        token: this.$store.getters.get__token,
        params: {
          sale: this.sale,
          charge: this.selectedPayments,
          turned: this.turned
        },
      })
        .then((response) => {
          let color = "";
          let message = "";
          if (response.statusCode == 200) {
            color = "success";
            message = "REGISTRADO CORRECTAMENTE";
            if (response.data.document_type_id == 3) {
              this.openTicket(response.data.voucher_id);
            } else {
              let res = response.data.data.sunat;
              window.open(res.json.enlace_del_pdf_ticket, "_blank");
            }
          } else {
            color = "danger";
            message = "error";
          }
          // Reseteamos la data
          // this.resetFormData();
          this.mtdClose(true);
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    resetFormData() {
      this.sale = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        // barber_id: "",
        // existingSportman: true,
        document_type_id: "",
        client_id: "",
        date: "",
        // type: 0,
        total: "",
        amount: "",
        pending: 0,
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        quote_id: "",
        sale_id: "",
        // typeAjustment: 0,
        // adjustment: 0,
        option: 0,
      };
      this.adjustmentType = 0;
      this.option = 0;
      this.adjustmentAmount = 0;
      (this.monto = ""), (this.selectedPayments = []);

      // Reset "Comprobante de Pago" selection
      this.data_comprobante_pago.forEach((item) => {
        item.selected = false;
      });

      // Limpiar los amount de" Método de Pago"
      this.data_metodo_pago.forEach((item) => {
        item.amount = "";
      });
    },
    showSale(sale_id) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/bySale/" +
          sale_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.sale.amount = response.data.data.amount;
          this.sale.pending = response.data.data.pending;
          this.sale.entity_document = response.data.data.cliente.document;
          this.sale.entity_name = response.data.data.client.name;
        })
        .catch((errors) => { });
    },
    openTicket(id) {
      window.open(
        this.$store.getters.get__url +
        "/cita/ticket/" +
        id +
        "/" +
        this.$props.id +
        "/" +
        this.$store.getters.get__user_id,
        "_blank"
      );
    },
    mtdSearchDocument: function () {
      if (this.sale.document_type_id == 1) {
        if (this.sale.entity_document.length == 8) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";

              Swal.fire({
                title: "DNI no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name =
                response.data.name + " " + response.data.last_name;
              this.sale.entity_address = response.data.direccion ?? "S/D";
            }
          });
        }
      } else if (this.sale.document_type_id == 2) {
        if (this.sale.entity_document.length == 11) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";
              Swal.fire({
                title: "RUC no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name = response.data.razon_social;
              this.sale.entity_address = response.data.direccion ?? "S/D";
            }
          });
        }
      } else if (this.sale.document_type_id == 3) {
        if (this.sale.entity_document.length == 8) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";
              Swal.fire({
                title: "DNI no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name =
                response.data.name + " " + response.data.last_name;
              this.sale.entity_address = response.data.direccion ?? "S/D";
            }
          });
        }
      }
    },
    /** ajuste */
    updateAjustment() {
      this.sale.typeAjustment = this.adjustmentType;
      this.sale.adjustment = 0;
      if (this.option == 1) {
        /** soles */
        // this.sale.adjustment =
        //   this.adjustmentType == 1
        //     ? this.adjustmentAmount
        //     : parseFloat(this.adjustmentAmount * -1);
        this.sale.adjustment =
          this.pagoTotal == 0
            ? this.adjustmentType == 1
              ? (parseFloat(this.sale.total) + parseFloat(this.adjustmentAmount)).toFixed(2)
              : (parseFloat(this.sale.total) + parseFloat(this.adjustmentAmount * -1)).toFixed(2)
            : this.adjustmentType == 1
              ? parseFloat(this.adjustmentAmount).toFixed(2)
              : parseFloat(this.adjustmentAmount * -1).toFixed(2);
      } else {
        /** % */
        const total = this.sale.total;
        let tempAdjustment = (total * this.adjustmentAmount) / 100;

        this.sale.adjustment =
          this.pagoTotal == 0
            ? this.adjustmentType == 1
              ? (parseFloat(total) + parseFloat(tempAdjustment)).toFixed(2)
              : (parseFloat(total) + parseFloat(tempAdjustment * -1)).toFixed(2)
            : this.adjustmentType == 1
              ? parseFloat(tempAdjustment).toFixed(2)
              : parseFloat(tempAdjustment * -1).toFixed(2);
      }
    },
    /** utlis */
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.bg-purple {
  background-color: #00003a;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  /* bg-info */
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>
